<template>
  <Dialog
    v-model:visible="visibleDialog"
    :style="{ width: '600px' }"
    header="Enviar Foto"
    :modal="true"
    @hide="hideDialog"
    class="p-fluid"
  >
    <FileUpload
      name="demo[]"
      accept="image/*"
      :maxFileSize="2000000"
      @select="onSelect"
      :showUploadButton="false"
      chooseLabel="Escolha um arquivo"
      cancelLabel="Cancelar"
    >
      <template #empty>
        <p>Nenhum arquivo selecionado</p>
      </template>
    </FileUpload>

    <div v-if="fileSelected != null">
      <div class="grid">
        <div class="col-12 md:col-6">
          <VueCropper
            ref="cropper"
            :src="fileSelected.base64"
            :aspect-ratio="50 / 50"
            style="background-color: #ddd; overflow: hidden"
          />
        </div>
        <div class="col-12 md:col-6">
          <img v-if="cropImg" :src="cropImg" class="img-fluid" />
        </div>
      </div>
    </div>

    <ProgressBar mode="indeterminate" v-if="initProgress" />

    <template #footer>
      <Button
        label="Cortar"
        class="p-button-raised p-button-success"
        icon="pi pi-pencil"
        @click="cropImage"
        v-if="fileSelected"
      />
      <Button
        label="Salvar"
        class="p-button"
        icon="pi pi-check"
        @click="onUpload"
        :disabled="fileSelected === null"
      />
      <Button
        label="Cancelar"
        icon="pi pi-times"
        class="p-button p-button-text"
        @click="hideDialog"
      />
    </template>
  </Dialog>
</template>
<script>
//Services
import OperatorService from "../../../service/operator/operator_service";

//VALIDATIONS
import { useVuelidate } from "@vuelidate/core";

//Components
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

export default {
  components: { VueCropper },
  props: ["objSelected"],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      service: new OperatorService(),
      fileSelected: null,
      initProgress: false,
      cropImg: null,
    };
  },
  computed: {
    visibleDialog: {
      get() {
        let value = this.$store.state.views.operator.dialogUpload;
        return value;
      },
      set(value) {
        this.$store.state.views.operator.dialogUpload = value;
      },
    },
  },
  methods: {
    onCancel() {
      this.fileSelected = null;
      this.cropImg = null;
    },
    onSelect(obj) {
      this.fileSelected = obj.files[0];

      let fileReader = new FileReader();

      fileReader.onload = () => {
        this.fileSelected.base64 = fileReader.result;
        this.cropImg = this.fileSelected.base64;
        this.$refs.cropper.replace(this.fileSelected.base64);
      };

      fileReader.readAsDataURL(this.fileSelected);
    },
    onUpload() {
      this.service
        .upload(this.objSelected.id, this.fileSelected)
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "Alerta!",
            detail: "Foto enviada com sucesso",
            life: 3000,
          });
          this.hideDialog();
        })
        .catch((err) => {
          this.initProgress = false;
          this.$msgErro(err);
        });
    },
    hideDialog() {
      this.fileSelected = null;
      this.initProgress = false;
      this.$emit("findAll");
      this.visibleDialog = false;
    },
    cropImage() {
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      this.fileSelected.base64 = this.cropImg;
      this.$ImageCropper.urlToFile(this.fileSelected).then((res) => {
        this.fileSelected = res;
      });
    },
  },
};
</script>
<style scoped></style>
